<script setup>
import { reactive, ref } from 'vue'
import { ElRadio, ElRadioGroup } from 'element-plus'  // ✅ 导入
import { sendCodes, authRegister, retrievePassword,authLogin } from "@/api/home";
import {
  payinOrder,
} from "@/api/user";
import {equipment } from "@/utils/index";
import md5 from "js-md5";

const plans = [
  {
    setMealNo:"1002",
    name: '永久苹果账号-香港',
    tag: '可下载大多数基础应用',
    currencySymbol:"$",
    salePrice:"2.78",
    period: '/ 月',
    accent: 'teal',
    summary: '香港账号，适用于香港地区。可下载大多数应用。',
    features: ['1个香港苹果id', '基础应用下载', '7x12 小时客服支持', '免费注册试用3天spv加速器'],
    cta: '立即购买',
  },
  {
    setMealNo:"1001",
    name: '永久苹果账号-美国',
    tag: '可下载几乎所有应用-推荐',
    currencySymbol:"$",
    salePrice:"2.99",
    period: '/ 月',
    accent: 'coral',
    summary: '美国账号，适用于美国地区。可下载几乎所有应用，推荐使用。',
    features: ['1个美国苹果id', '大多数应用下载', '7x12 小时客服支持', '免费注册试用3天spv加速器'],
    cta: '立即购买',
    featured: true,
  },
]

const activePlan = ref('')
        // 验证码倒计时

const forms = reactive(
  Object.fromEntries(
    plans.map((plan) => [
      plan.name,
      {
        email: '',
        code: '',
        sent: false,
        sending: false,
        sendError: '',
        touched: false,
        submitted: false,
        password: '888888',
        payment: 'wechat', // ✅ 默认微信支付
      },
    ]),
  ),
)

const countdown = reactive({
  timeOut: 0,
  timeShow: false,
  timer: null
})

const regForm = reactive({
        appName: "spv", //	注册app名字
        versionNumber: "1.2.7", //注册app版本
        channelNo: "50001", //	推广商渠道编号
        channelType: "0", //	渠道类型：1-正常包 2-分享包 3-下载包 默认0
        deviceId: "", //	注册设备id
        deviceName: "", //	设备名称
        email: "", //	邮箱
        inviter: "", //	邀请人个人码
        xhnDigitalId: "", //	关联id
        password: "", //	提交的加密密码
        platform: "5", //	注册平台, 1-Android 2-IOS 3-win 4-macOS 5-web
        userType: "2", //	用户类型： 1-手机 2-邮箱
        verifyCode: "", //	验证码
        //登录用
        username: "", //账号
})

const couponNo = ""
const orderAll= {
        // 下单编号
        orderNumber: "",
        // 下单的计时器
        timer: null,
        timerNum: 0,
      }

async function selectPlan(planName) {
  const form = forms[planName]
  // 如果表单未展开，先展开
  if (!form.isExpanded) {
    form.isExpanded = true
    activePlan.value = planName
    return
  }

  activePlan.value = planName
  form.touched = true
  form.submitted = false



  if (!form.email || !form.code) return

  let emailflag =
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (emailflag.test(form.email) && form.code.length===6) {
    regForm.password = md5(form.password);
    regForm.username = form.email;
    regForm.email = form.email;
    regForm.verifyCode = form.code;
    // 注册 走这里
    regForm.userType = "2";
    const { deviceId, deviceName } = equipment();
    regForm.deviceId = deviceId;
    regForm.deviceName = deviceName;
    let data = JSON.parse(JSON.stringify(regForm));
    const res = await authRegister(data);
    console.log(res.data.msg);
    if (res.data.code === 10102||res.data.code === 200) {
      if (res.data.code === 10102) {
        //账号已存在，重置
        const resRtp = await retrievePassword({
            password: regForm.password,
            email: regForm.email,
            verifyCode: regForm.verifyCode,
        });
        console.log(resRtp);
        if (resRtp.data.code !== 200){
          alert(resRtp.data.msg);
        }
      }
      //用新密码登录
      const resLogin = await authLogin(data);
      console.log(resLogin);
      if (resLogin.data.code === 200){
        localStorage.setItem('access_token', resLogin.data.data.access_token);
        //登录成，创建订单
        const busiCode = form.payment === 'wechat' ? '100101' : '100200'
        // ✅ 获取当前套餐
        const currentPlan = plans.find(plan => plan.name === planName)
        
        const resOrder = await payinOrder({
          busiCode: busiCode,
          channelNo: regForm.channelNo,
          orderPayAmount: currentPlan.salePrice,
          platform: regForm.platform,
          couponNos: couponNo,
          setmealNo: currentPlan.setMealNo,
        });
        orderAll.orderNumber = resOrder.data.data.orderNo;
        form.submitted = true
        const devices = equipment().deviceName;
        if (devices === "iPhone"||devices === "iPad"||devices === "Mac") {
            setTimeout(() => {
            window.location.href = resOrder.data.data.payUrl;
          }, 100);
        } else {
          window.open(resOrder.data.data.payUrl, "_blank");
        }
        this.getOrder();
      }else{
        alert(resLogin.data.msg);
      }

    }else{
      alert(res.data.msg);
    }
    console.log(res);

    console.log(res);
    
        
  }else{
    alert('请输入正确邮箱和验证码')
  }
  
}

async function sendCode(planName) {
  const form = forms[planName]
  form.touched = true
  form.sent = false
  form.sendError = ''

  let emailflag =
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailflag.test(form.email)) {
    alert('请输入正确邮箱')
    return
  }
  if(!form.sending && !countdown.timeShow) {
    form.sending = true
    countdown.timeOut = 60;
    countdown.timeShow = true;
    countdown.timer = setInterval(() => {
            --countdown.timeOut;
            if (countdown.timeOut <= 0) {
              clearInterval(countdown.timer);
              countdown.timeShow = false;
              countdown.timeOut = null;
            }
    }, 1000);
    sendCodes({
      username: form.email,
      codeBizType: "1",
      appName: "spv",
    }).then((res) => {
            console.log(res.data.msg);
            if (res.data.code === 200) {
              form.sent = true
            }else{
              form.sendError = res.data.msg
            }
            
            console.log(res);
      });

  }
  else{
    alert('发送中，请稍后再试')
  }
  form.sending = false
}

function needsEmail(planName) {
  return forms[planName].touched && !forms[planName].email
}

function needsCode(planName) {
  return forms[planName].touched && !forms[planName].code
}
</script>

<template>
  <main class="page-shell">
    <section class="pricing">
      <div class="intro">
        <p class="eyebrow">商品套餐</p>
        <h1>选择更适合你的海外苹果ID</h1>
        <p class="lead">购买海外苹果id，解锁更多好玩的苹果应用，让您的生活更加舒适美好。</p>
      </div>

      <div class="plan-grid">
        <article
          v-for="plan in plans"
          :key="plan.name"
          class="plan-card"
          :class="[{ featured: plan.featured }, plan.accent]"
        >
          <div class="card-top">
            <div>
              <p class="plan-tag">{{ plan.tag }}</p>
              <h2>{{ plan.name }}</h2>
            </div>
            <span v-if="plan.featured" class="badge">热门</span>
          </div>

          <p class="summary">{{ plan.summary }}</p>

          <div class="price-row">
            <span class="price">{{ plan.currencySymbol }}{{ plan.salePrice }}</span>
            <!--span class="period">{{ plan.period }}</span-->
          </div>

          <ul class="features" aria-label="套餐权益">
            <li v-for="feature in plan.features" :key="feature">
              <span class="check">✓</span>
              <span>{{ feature }}</span>
            </li>
          </ul>

          <div class="signup-area">
            <form v-if="activePlan === plan.name" class="verify-form" @submit.prevent>
              <label class="field">
                <span>邮箱</span>
                <input
                  v-model="forms[plan.name].email"
                  type="email"
                  placeholder="请输入邮箱地址"
                  autocomplete="email"
                  :aria-invalid="needsEmail(plan.name)"
                />
                <small v-if="needsEmail(plan.name)" class="field-error">请填写邮箱。</small>
              </label>

              <div class="code-row">
                <label class="field code-field">
                  <span>验证码</span>
                  <input
                    v-model="forms[plan.name].code"
                    type="text"
                    inputmode="numeric"
                    placeholder="6 位验证码"
                    maxlength="6"
                    :aria-invalid="needsCode(plan.name)"
                  />
                  <small v-if="needsCode(plan.name)" class="field-error">请填写验证码。</small>
                </label>

                <button
                  class="code-button"
                  type="button"
                  :disabled="!forms[plan.name].email || forms[plan.name].sending || countdown.timeShow"
                  @click="sendCode(plan.name)"
                  :loading="countdown.timeShow"
                >
                  {{ countdown.timeShow ? countdown.timeOut + "s" : "发送" }}
                </button>
              </div>
              <!-- ✅ 添加支付方式选择 -->
  <div class="payment-methods">
    <label class="field payment-label">
      <span></span>
    </label>
    <el-radio-group v-model="forms[plan.name].payment" class="payment-radio-group">
      <el-radio label="wechat" class="payment-radio">
        <span class="payment-option-content">
          <img 
            src="@/assets/wechat-pay.png" 
            alt="微信支付" 
            class="payment-icon"
          />
          微信支付
        </span>
      </el-radio>
      <el-radio label="alipay" class="payment-radio">
        <span class="payment-option-content">
          <img 
            src="@/assets/alipay.png" 
            alt="支付宝支付" 
            class="payment-icon"
          />
          支付宝支付
        </span>
      </el-radio>
    </el-radio-group>
  </div>
              <p v-if="forms[plan.name].sent" class="form-note">验证码已发送，请查看邮箱。</p>
              <p v-if="forms[plan.name].sendError" class="form-error">
                {{ forms[plan.name].sendError }}
              </p>
              <p v-if="forms[plan.name].submitted" class="form-success">
                已提交 {{ plan.name }}，我们会根据邮箱继续处理。
              </p>
            </form>
            <button class="action-button" type="button" @click="selectPlan(plan.name)">
              {{ plan.cta }}
            </button>
          </div>
          
        </article>
      </div>
    </section>
  </main>
</template>

<style scoped>
/* ✅ 支付方式样式 */
.payment-methods {
  margin-top: 4px;
}

.payment-label {
  margin-bottom: 6px;
}

.payment-label span {
  color: #4d5956;
  font-size: 0.86rem;
  font-weight: 800;
}

.payment-radio-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  width: 100%;
}

/* ✅ 自定义 Radio 样式 */
.payment-radio {
  margin-right: 0 !important;
  padding: 10px 12px;
  min-height: 44px;
  border: 1px solid rgba(24, 32, 31, 0.14);
  border-radius: 8px;
  background: #ffffff;
  transition: all 180ms ease;
  position: relative;
}

/* 隐藏默认的 radio 圆圈 */
.payment-radio :deep(.el-radio__input) {
  display: none;
}

.payment-radio :deep(.el-radio__label) {
  padding-left: 0 !important;
  width: 100%;
}

.payment-option-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 650;
  color: #26312f;
  font-size: 0.92rem;
}

/* ✅ 图片统一大小 */
.payment-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
  flex-shrink: 0;
}

/* ✅ Hover 状态 */
.payment-radio:hover {
  border-color: #4da498;
  box-shadow: 0 0 0 4px rgba(77, 164, 152, 0.14);
}

/* ✅ 选中状态 */
.payment-radio.is-checked {
  border-color: #4da498 !important;
  background: rgba(77, 164, 152, 0.08) !important;
  box-shadow: 0 0 0 4px rgba(77, 164, 152, 0.14) !important;
}

/* 专业套餐（珊瑚色） */
.plan-card.coral .payment-radio:hover {
  border-color: #de6b55;
  box-shadow: 0 0 0 4px rgba(222, 107, 85, 0.14);
}

.plan-card.coral .payment-radio.is-checked {
  border-color: #de6b55 !important;
  background: rgba(222, 107, 85, 0.08) !important;
  box-shadow: 0 0 0 4px rgba(222, 107, 85, 0.14) !important;
}

/* ✅ 选中标记（替代默认 radio 圆圈） */
.payment-radio.is-checked .payment-option-content::after {
  content: '✓';
  position: absolute;
  top: -6px;
  right: -6px;
  display: inline-grid;
  width: 20px;
  height: 20px;
  place-items: center;
  border-radius: 50%;
  background: #4da498;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 900;
}

.plan-card.coral .payment-radio.is-checked .payment-option-content::after {
  background: #de6b55;
}

/* ✅ 响应式 */
@media (max-width: 760px) {
  .payment-radio-group {
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  
  .payment-radio {
    padding: 8px 10px;
    min-height: 40px;
  }
  
  .payment-option-content {
    font-size: 0.85rem;
  }
  
  .payment-icon {
    width: 20px;
    height: 20px;
  }
}

@media (max-width: 480px) {
  .payment-radio-group {
    grid-template-columns: 1fr;
  }
}
</style>